<template>
    <!-- 提现设置 -->
    <ZhaiHead></ZhaiHead>

    <div class="container-fluid zhu px-0">
        <div class="row shengse">

            <div class="dixian px-4 py-2 top-bar">
                <div class="promo-title" @click="goBack">
                    <i class="fa fa-bullhorn"></i>推广中心
                </div>
                <div class="top-center-title" @click="goWalletSettings">提现设置</div>
                <div class="top-right" @click="goMyWallet">
                    钱包 <span class="arrow">›</span>
                </div>

            </div>


            <div class="content-wrap">
                <!-- 真实姓名设置 -->
                <div class="section-title">真实姓名设置（如选USDT方式此项可不填）</div>
                <div class="cell">
                    <div class="cell-left">真实姓名</div>
                    <input
                            class="cell-input"
                            v-model.trim="form.realName"
                            type="text"
                            placeholder="请输入真实姓名"
                    />
                </div>

                <!-- USDT账号设置 -->
                <div class="section-title">USDT账号设置</div>
                <div class="cell">
                    <div class="cell-left">USDT地址</div>
                    <input
                            class="cell-input"
                            v-model.trim="form.usdtAddress"
                            type="text"
                            placeholder="请输入账号"
                    />
                </div>

                <!-- 支付宝账户设置 -->
                <div class="section-title">支付宝账户设置</div>
                <div class="cell">
                    <div class="cell-left">支付宝账号</div>
                    <input
                            class="cell-input"
                            v-model.trim="form.alipayAccount"
                            type="text"
                            placeholder="请输入支付宝账号"
                    />
                </div>

                <!-- 银行账户设置 -->
                <div class="section-title">银行账户设置</div>


                <div class="cell cell-click" ref="bankCell" @click="chooseBank">
                    <div class="cell-left">开户行</div>
                    <div class="cell-right">
            <span class="cell-right-text" :class="{ placeholder: !form.bankName }">
              {{ form.bankName || "请选择开户行" }}
            </span>
                        <i class="fa fa-angle-right arrow"></i>
                    </div>
                </div>

                <!-- 账号 -->
                <div class="cell">
                    <div class="cell-left">账号</div>
                    <input class="cell-input" :value="form.bankAccount" @input="onBankAccountInput($event.target.value)" />

                </div>

                <!-- ✅ 贴着开户行的下拉选择列表（模仿截图） -->
                <div v-if="showBankPicker" class="bank-mask" @click="closeBankPicker">
                    <div
                            class="bank-panel bank-panel-dropdown"
                            :style="bankPanelStyle"
                            @click.stop
                    >
                        <div class="bank-title">请选择开户行</div>

                        <div class="bank-list">
                            <div
                                    v-for="item in bankOptions"
                                    :key="item"
                                    class="bank-item"
                                    :class="{ active: item === form.bankName }"
                                    @click="selectBank(item)"
                            >
                                {{ item }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 提交按钮 -->
                <div class="submit-wrap">
                    <button class="btn-submit" @click="onSubmit">提交</button>
                </div>
            </div>
        </div>
    </div>

    <ZhaiFoot></ZhaiFoot>
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import { mapGetters } from "vuex";
    import http from "../utils/http.js";

    export default {
        name: "MWalletSettings",
        components: { ZhaiHead, ZhaiFoot },

        data() {
            return {
                /** ====== API 路径（与 PC 一致）====== */
                API_PROFILE: "/platform/withdraw/profile",

                form: {
                    realName: "",
                    usdtAddress: "",
                    alipayAccount: "",
                    bankName: "", // 开户行显示名称
                    bankAccount: "",
                },

                // ✅ 银行下拉数据 + 显示控制（保留你原来的）
                showBankPicker: false,
                bankOptions: ["工商银行", "建设银行", "中国银行", "交通银行", "农业银行", "邮政银行"],

                // ✅ 下拉框定位样式（保留你原来的）
                bankPanelStyle: { top: "0px", left: "0px", width: "300px" },

                currentUserId: null,
                saving: false,
                loadingProfile: false,
            };
        },

        computed: {
            ...mapGetters(["getUser"]),
        },

        // ✅ 路由守卫：未登录直接跳登录页（与 PC 一致）
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            // mounted 兜底：防直开页面
            const token = localStorage.getItem("token");
            if (!token) {
                this.$router.replace("/login");
                return;
            }

            this.currentUserId = this.resolveUserIdSafe();

            // ✅ 页面打开拉回填（与 PC 一致）
            await this.loadWithdrawProfile();
        },

        methods: {
            // ================== 通用提示（兼容 toast/alert） ==================
            toast(msg) {
                return this.$toast ? this.$toast(msg) : alert(msg);
            },

            // ================== 登录失效处理 ==================
            redirectToLogin() {
                this.$router.replace("/login");
            },

            isAuthExpired(err, json) {
                const code = err?.response?.status;
                if (code === 401 || code === 403) return true;

                const s = json?.status;
                if (s === 401 || s === 403 || s === -1) return true;

                const msg = String(json?.msg || err?.message || "");
                if (/token|登录|未登录|过期|失效|unauthorized|forbidden/i.test(msg)) return true;

                return false;
            },

            // ================== 更稳的 userId 获取（与 PC 一致） ==================
            resolveUserIdSafe() {
                // 1) Vuex
                const u = this.getUser || {};
                if (u && u.id) return u.id;

                // 2) localStorage 常见存法
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                return null;
            },

            // ================== 回填：从后端取 withdraw_profile（与 PC 一致） ==================
            async loadWithdrawProfile() {
                if (this.loadingProfile) return;
                this.loadingProfile = true;

                try {
                    const params = this.currentUserId ? { userId: this.currentUserId } : null;
                    const res = await http.get(this.API_PROFILE, params);
                    const json = res?.data;

                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || json.status !== 1) {
                        // 回填失败不强制弹窗，避免“打开就弹”
                        console.warn("[WithdrawProfile] load failed:", json);
                        return;
                    }

                    const d = json.data || {};

                    // ✅ 字段映射：完全对齐 PC（兼容 snake_case）
                    this.form.realName = d.realName || d.real_name || "";
                    this.form.usdtAddress = d.usdtAddress || d.usdt_address || "";
                    this.form.alipayAccount = d.alipayAccount || d.alipay_account || "";

                    // 银行字段：PC 里你用了 bankName + bankAccount（此处兼容 bankCardNo 等）
                    this.form.bankName = d.bankName || d.bank_name || "";
                    this.form.bankAccount =
                        d.bankAccount ||
                        d.bank_account ||
                        d.bankCardNo ||
                        d.bank_card_no ||
                        d.bankCardNo ||
                        "";

                    // ✅ 兜底：若银行卡号为空却有 bankName，强制清空 bankName（与 PC 一致）
                    if (!String(this.form.bankAccount || "").trim()) {
                        this.form.bankName = "";
                    }
                } catch (e) {
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }
                    console.error("[WithdrawProfile] error:", e);
                } finally {
                    this.loadingProfile = false;
                }
            },

            // ================== ✅ 核心修复：银行卡号输入变化（与 PC 一致） ==================
            onBankAccountInput(val) {
                const raw = val ?? "";
                const v = String(raw).trim();

                // 保留用户原输入（你手机端原来用了 v-model.trim，会吞空格）
                // 这里依然写回 form.bankAccount
                this.form.bankAccount = raw;

                // ⭐ 关键：银行卡号被清空 => 同步清空开户行
                if (!v) {
                    this.form.bankName = "";
                }
            },

            // ================== 提交：保存 withdraw_profile（与 PC 一致） ==================
            async onSubmit() {
                if (this.saving) return;

                const f = this.form || {};
                const realName = (f.realName || "").trim();
                const usdt = (f.usdtAddress || "").trim();
                const alipay = (f.alipayAccount || "").trim();
                const bankName = (f.bankName || "").trim();
                const bankAccount = (f.bankAccount || "").trim();

                const hasUSDT = !!usdt;
                const hasAlipay = !!alipay;
                const hasBankAny = !!bankName || !!bankAccount;
                const hasAnyAccount = hasUSDT || hasAlipay || hasBankAny;

                // ---------- 1) 全空 ----------
                if (!realName && !hasAnyAccount) {
                    return this.toast("请填写真实姓名，并至少选择一种账户填写账号");
                }

                // ---------- 2) 只填真实姓名 ----------
                if (realName && !hasAnyAccount) {
                    return this.toast("至少选择一种账户填写账号");
                }

                // ---------- 3) 银行块：填了任意项则必须全填 ----------
                if (hasBankAny) {
                    if (!bankName) return this.toast("请选择开户行");
                    if (!bankAccount) return this.toast("请输入银行卡号");
                }

                // ---------- 4) 如果包含 银行或支付宝，则真实姓名必须非空 ----------
                if ((hasBankAny || hasAlipay) && !realName) {
                    return this.toast("请输入真实姓名");
                }

                // ---------- 5) 常理格式校验 ----------
                if (realName) {
                    if (!this.isChinaRealName(realName)) {
                        return this.toast("真实姓名格式不正确，请填写中文姓名");
                    }
                }

                if (hasAlipay) {
                    if (!this.isValidAlipayAccount(alipay)) {
                        return this.toast("支付宝账号格式不正确（请输入手机号或邮箱）");
                    }
                }

                if (hasBankAny) {
                    if (!this.isValidBankCard(bankAccount)) {
                        return this.toast("银行卡号格式不正确");
                    }
                }

                if (hasUSDT) {
                    if (!this.isValidUSDTAddress(usdt)) {
                        return this.toast("USDT地址格式不正确");
                    }
                }

                // ✅ ✅ ✅ 最关键兜底：银行卡号为空 => 强制清空开户行（与 PC 一致）
                if (!bankAccount) {
                    this.form.bankName = "";
                }

                const payload = {
                    realName: realName || "",
                    usdtAddress: usdt || "",
                    alipayAccount: alipay || "",
                    bankName: (bankAccount ? bankName : "") || "",
                    bankAccount: bankAccount || "",
                };

                this.saving = true;
                try {
                    const url = this.currentUserId ? `${this.API_PROFILE}?userId=${this.currentUserId}` : this.API_PROFILE;
                    const res = await http.post(url, payload);
                    const json = res?.data;

                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || json.status !== 1) {
                        return this.toast(json?.msg || "提交失败，请稍后重试");
                    }

                    this.toast("已提交");

                    // ✅ 提交后可选择回填一次（对齐 PC 行为：覆盖更新）
                    await this.loadWithdrawProfile();
                } catch (e) {
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }
                    console.error(e);
                    this.toast("提交失败，请稍后重试");
                } finally {
                    this.saving = false;
                }
            },

            // ========= 真实姓名校验 =========
            isChinaRealName(name) {
                const s = String(name).trim();
                if (s.length < 2 || s.length > 10) return false;
                return /^[\u4e00-\u9fa5]{2,10}([\u00b7·][\u4e00-\u9fa5]{2,10})?$/.test(s);
            },

            // ========= 支付宝账号校验 =========
            isValidAlipayAccount(v) {
                const s = String(v).trim();
                const isPhone = /^1[3-9]\d{9}$/.test(s);
                const isEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(s);
                return isPhone || isEmail;
            },

            // ========= 银行卡号校验 =========
            isValidBankCard(v) {
                const s = String(v).replace(/\s/g, "");
                if (!/^\d+$/.test(s)) return false;
                return s.length >= 10 && s.length <= 30;
            },

            // ========= USDT 地址校验 =========
            isValidUSDTAddress(v) {
                const s = String(v).trim();
                const isERC20 = /^0x[a-fA-F0-9]{40}$/.test(s);
                const isTRC20 = /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(s);
                return isERC20 || isTRC20;
            },

            // ================== 页面跳转（保留你的） ==================
            goBack() {
                if (this.$router) this.$router.push("/Promotion");
                else window.location.href = "/Promotion";
            },
            goMyWallet() {
                if (this.$router) this.$router.push("/MyWallet");
                else window.location.href = "/MyWallet";
            },
            goWalletSettings() {
                if (this.$router) this.$router.push("/WalletSettings");
                else window.location.href = "/WalletSettings";
            },

            // ✅ 打开下拉，并定位到“开户行”这一行下面（保留你的）
            chooseBank() {
                this.showBankPicker = true;

                this.$nextTick(() => {
                    const el = this.$refs.bankCell;
                    if (!el) return;

                    const rect = el.getBoundingClientRect();
                    const width = rect.width;
                    const top = rect.bottom + 6;
                    const left = rect.left;

                    const maxLeft = window.innerWidth - width - 10;
                    const safeLeft = Math.max(10, Math.min(left, maxLeft));
                    const safeTop = Math.min(top, window.innerHeight - 420);

                    this.bankPanelStyle = {
                        top: `${safeTop}px`,
                        left: `${safeLeft}px`,
                        width: `${width}px`,
                    };
                });
            },

            // ✅ 选中银行（保留你的）
            selectBank(name) {
                this.form.bankName = name;
                this.showBankPicker = false;
            },

            // ✅ 点击空白关闭（保留你的）
            closeBankPicker() {
                this.showBankPicker = false;
            },
        },

        // ✅ 关键：用 watcher 兜底“银行卡号被清空 => 清空开户行”（即使你 template 仍用 v-model.trim）
        watch: {
            "form.bankAccount"(val) {
                const v = String(val || "").trim();
                if (!v) this.form.bankName = "";
            },
        },
    };
</script>

<style scoped>
    .fa {
        margin-right: 6px;
    }

    /* 页面容器（你原来的） */
    .zhu {
        margin-top: 80px;
        height: calc(100vh - 80px);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    /* 顶部栏三列布局：左 中 右 */
    .top-bar {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
    }
    .top-center-title {
        justify-self: center;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #00c26f;
    }
    .top-right {
        justify-self: end;
        font-size: 14px;       /* 跟设置一样 */
        color: #00c26f;        /* 跟设置一样 */
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .top-right:active {
        opacity: 0.7;
    }

    .promo-title {
        cursor: pointer;
        user-select: none;
        font-size: 16px;
        color: #333;
    }
    .promo-title:active {
        opacity: 0.7;
    }

    /* ✅ 内容区：你原来的（保留） */
    .content-wrap {
        flex: 1;
        overflow-y: auto;
        background: #f3f4f6;
        padding-bottom: 28px;
        position: relative;
    }

    /* 分组标题（灰条文字） */
    .section-title {
        font-size: 13px;
        color: #9aa0a6;
        padding: 14px 16px 10px;
    }

    /* 单元行（白底） */
    .cell {
        background: #fff;
        min-height: 54px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        border-top: 1px solid #f0f0f0;
    }
    .cell:first-of-type {
        border-top: none;
    }

    /* 左侧标题 */
    .cell-left {
        width: 92px;
        font-size: 16px;
        color: #111;
        flex-shrink: 0;
    }

    /* 输入框（右侧） */
    .cell-input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 16px;
        color: #666;
        background: transparent;
    }
    .cell-input::placeholder {
        color: #b8b8b8;
    }

    /* 可点击的选择行 */
    .cell-click {
        cursor: pointer;
    }
    .cell-click:active {
        background: #fafafa;
    }

    /* 右侧显示 + 箭头 */
    /* ✅ 占位文本：必须像普通文字一样显示 */
    .cell-right-text.placeholder {
        color: #b8b8b8;
        background: transparent !important;
        padding: 0 !important;
        min-width: 0 !important;
        height: auto !important;
        line-height: normal !important;
        display: inline;          /* 🔥 关键：不要是 block / inline-block */
    }
    .cell-right{
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end; /* ✅ 让内容整体靠右 */
        gap: 10px;
        width: 180px;              /* ✅ 给右侧一个固定/最小宽度，防止“左移” */
    }



    .cell-right-text {
        font-size: 16px;
        color: #666;
    }
    .cell-right-text.placeholder {
        color: #b8b8b8;
    }
    .arrow {
        font-size: 22px;
        color: #c9c9c9;
        margin-right: 0;
    }

    /* 提交按钮区域 */
    .submit-wrap {
        padding: 22px 16px 0;
    }
    .btn-submit {
        width: 100%;
        height: 52px;
        border: none;
        border-radius: 10px;
        font-size: 18px;
        color: #fff;
        background: linear-gradient(90deg, #f15a5a, #ff8a66);
        box-shadow: 0 6px 16px rgba(241, 90, 90, 0.18);
    }
    .btn-submit:active {
        transform: translateY(1px);
        opacity: 0.92;
    }

    /* ✅ 银行下拉：遮罩（透明，点空白关闭） */
    .bank-mask {
        position: fixed;
        inset: 0;
        background: transparent;
        z-index: 9999;
    }

    /* ✅ 银行下拉：贴着开户行下面 */
    .bank-panel.bank-panel-dropdown {
        position: fixed;
        background: #fff;
        border: 1px solid #dcdcdc;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
    }

    /* 标题 */
    .bank-title {
        padding: 12px 14px;
        font-size: 18px;
        font-weight: 700;
        color: #111;
        border-bottom: 1px solid #e9e9e9;
    }

    /* 列表 */
    .bank-list {
        max-height: 360px;
        overflow: auto;
    }

    /* 列表项（字体更大，接近截图） */
    .bank-item {
        padding: 14px 14px;
        font-size: 22px;
        line-height: 1.2;
        color: #111;
        cursor: pointer;
        user-select: none;
    }

    .bank-item:hover {
        background: #f5f7ff;
    }

    /* ✅ 选中项蓝色高亮（模仿截图） */
    .bank-item.active {
        background: #1f66d1;
        color: #fff;
    }
</style>
